module.exports = __webpack_public_path__ + "public/SiteIcons/hostingBlockImage2.png?d2f169bf";